<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fModalidadesAutorizaciones" name="nomModalidadesAutorizaciones">
    <div class="grid ">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'MODALIDADES.LBL_DOCUMENTO' | translate }}</label>
          <p-dropdown disableTab  id="idAutorizacion" name="nomAutorizacion" [options]="lisAutorizaciones"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                      filter="filter"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idAutorizacion"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idAutorizacion.invalid">
            {{ 'MODALIDADES.MSG_DOCUMENTOREQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6 pt-4">
        <div class="div-form btn-block">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas"
               [value]="autorizaciones" selectionMode="single" dataKey="idAutorizacion"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.label}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_ELIMINAR' | translate}}"
                        pButton (click)="eliminarModalidadAutorizacion(row.value)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="productos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
